/* eslint-disable func-names */
import _ from 'lodash';
import { call, put } from 'redux-saga/effects';
import { notify } from '../../Actions/ui';

export default (loadingAction, loadingMessage, saga, ...sagaArgs) =>
  call(function* () {
    const notifyLoading = _.isFunction(loadingAction);

    try {
      if (notifyLoading) {
        yield put(loadingAction(true, loadingMessage));
      }

      return yield call(saga, ...sagaArgs);
    } catch (err) {
      console.error(err);
      yield put(notify(err.message, 'error'));
    } finally {
      if (notifyLoading) {
        yield put(loadingAction(false));
      }
    }
  });
